import { withSvgIcon } from './withSvgIcon';

export const Warning = withSvgIcon(
  <>
    <path
      clipRule="evenodd"
      d="M24 40C32.8366 40 40 32.8366 40 24C40 15.1634 32.8366 8 24 8C15.1634 8 8 15.1634 8 24C8 32.8366 15.1634 40 24 40ZM24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
      fillRule="evenodd"
      fill="currentColor"
    />
    <path
      d="M26.3994 30.9468C26.3994 32.2722 25.3249 33.3467 23.9995 33.3467C22.6741 33.3467 21.5996 32.2722 21.5996 30.9468C21.5996 29.6213 22.6741 28.5469 23.9995 28.5469C25.3249 28.5469 26.3994 29.6213 26.3994 30.9468Z"
      fill="currentColor"
    />
    <path
      d="M21.6948 14.6576C21.6656 14.3078 21.9417 14.0078 22.2927 14.0078H25.7485C26.0995 14.0078 26.3755 14.3078 26.3464 14.6576L25.4464 25.4576C25.4205 25.7686 25.1605 26.0078 24.8485 26.0078H23.1927C22.8807 26.0078 22.6207 25.7686 22.5948 25.4576L21.6948 14.6576Z"
      fill="currentColor"
    />
  </>,
  { viewBox: '0 0 48 48' },
);
